<template>
  <div class="page page-back-cover">
    <div class="back-cover-header">
      <div class="back-cover-header-title">
        trusted brands. one go-to source.
      </div>
      <div class="back-cover-top">
        <div class="back-cover-top-logo" v-if="hasLogo">
          <img :src="this.dealer.logo" />
        </div>
        <div class="back-cover-top-info" v-if="hasRep && projectRep">
          <div class="rep-name">
            {{ projectRep.name }}
          </div>
          <div class="rep-email">
            {{ projectRep.email }}
          </div>
          <div class="rep-phone">
            {{ projectRep.phone }}
          </div>
        </div>
      </div>
    </div>
    <div class="back-cover-graphic" v-if="backCoverLogo">
      <img
        v-if="anonymousCrossOrigin"
        crossorigin="anonymous"
        :src="coverLogo"
      />
      <img v-else :src="coverLogo" />
    </div>
    <div class="back-cover-promo-area">
      <BackCoverUAPromoArea v-if="isUATemplate" />
      <BackCoverFSGPromoArea v-else />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import BackCoverUAPromoArea from "@/components/Projects/Playbooks/BackCover/BackCoverUAPromoArea";
import BackCoverFSGPromoArea from "@/components/Projects/Playbooks/BackCover/BackCoverFSGPromoArea";

export default {
  name: "BackCover",
  computed: {
    ...mapState("playbook", ["team_name"]),
    ...mapState("project", [
      "projectLogos",
      "spiritwearLogoId",
      "uniformsLogoId",
    ]),
    ...mapGetters("project", ["projectColors", "defaultLogo", "projectRep"]),
    ...mapGetters("playbook", ["isUATemplate"]),
    ...mapState(["dealer"]),

    coverLogo() {
      return this.backCoverLogo.content || this.backCoverLogo.url;
    },

    hasLogo() {
      return !!this.dealer?.logo;
    },

    hasRep() {
      return !!this.projectRep;
    },

    backCoverLogo() {
      return this.defaultLogo;
    },

    spiritwearLogo() {
      const spiritwearLogo = this.projectLogos.filter((logo) => {
        return logo.id == this.spiritwearLogoId;
      })[0];

      return spiritwearLogo;
    },

    uniformsLogo() {
      const uniformsLogo = this.projectLogos.filter((logo) => {
        return logo.id == this.uniformsLogoId;
      })[0];

      return uniformsLogo;
    },
  },
  components: {
    BackCoverUAPromoArea,
    BackCoverFSGPromoArea,
  },
  props: {
    anonymousCrossOrigin: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  .page-back-cover {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .back-cover-header {
      display: flex;
      flex-direction: column;
      height: 30%;
      .back-cover-header-title {
        padding: 1.5em 0 1em;
        text-align: center;
        font-family: "ForzaBold";
        text-transform: uppercase;
        font-size: 1.75em;
      }
      .back-cover-top {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        width: 100%;
        padding: 1em;

        .back-cover-top-logo {
          max-height: 100%;
          max-width: 50%;
          padding: 0 2em;
          img {
            max-width: 100%;
            max-height: 15em;
          }
        }

        .back-cover-top-info {
          display: flex;
          flex-direction: column;
          font-weight: bold;
          font-size: 1.2em;
          font-style: italic;
        }
      }
    }
    .back-cover-graphic {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50%;
      max-width: 100%;
      max-height: 30em;
      max-width: 30em;
      padding: 0;
      margin: 0 auto;
      img {
        width: 100%;
        max-width: 100%;
        max-height: 100%;
      }
    }
    .back-cover-promo-area {
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 2em;
      height: 15%;
      .promo-area-row {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        font-size: 0.8em;
        margin: 1em 0;
        .promo-area-col {
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            max-width: 50%;
          }
          p {
            margin-top: 0.5em;
          }
          a,
          a:hover,
          a:active,
          a:visited {
            margin: 0.5em 0;
            color: black;
            text-decoration: none;
          }
          &.promo-area-col-sm {
            img {
              max-height: 6em;
            }
          }
        }
      }
    }
  }
}
</style>
